import styled from 'styled-components';

import colors from '../../../../../styles/colors';
import { HeroImageWrapper } from '../../../Config/components/CheckoutPageConfiguration/HeroImageSetting/styles';

/* Phones show the contact photo as a circle, so it is cropped square. */
const ContactPhotoWrapper = styled(HeroImageWrapper)`
  aspect-ratio: 1;
`;

const ContactPhotoPreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

/* The same 16:9 frame leads see the media in on the end screen. */
const MediaFrame = styled.div`
  width: 320px;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background-color: ${colors.base.beta};

  video,
  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  video {
    object-fit: contain;
  }

  img {
    object-fit: cover;
  }
`;

const MediaActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export {
  ContactPhotoWrapper,
  ContactPhotoPreview,
  MediaFrame,
  MediaActions,
};
